import { useEffect, useState } from "react";
import { getModelList, downloadModel, getModelDetail, createModel } from "../assets/constants/global_apis";
import SearchMenu from "../components/SearchMenu";
import { FilesInfo } from "../components/FilesInfo";
import AlertPopup, { triggerAlert } from "../components/AlertMessage";
import '../assets/styles/datasets_models.css'
import { Card, CardContent, Typography, CircularProgress } from "@mui/material";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { NeuralNetworkSvg } from "../icon_templates/icons";
import BarChart from "../components/BarChart";
import ConfusionMatrixHeatmap from "../components/ConfusionMetrics";

export default function Models() {
    const [models, setModels] = useState([]);
    const [initialModels, setInitialModels] = useState([]);
    const [selectedModel, setSelectedModel] = useState({});
    const [showModelView, setShowModelView] = useState(false);
    const [metricsData, setMetricsData] = useState(null);
    const [overalMetrics, setOveralMetrics] = useState(null);
    const [loading, setLoading] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [errors, setErrors] = useState({});
    const [singleData, setSingleData] = useState([]);
    const [modelLoading, setModelLoading] = useState(false);
    const [multipleData, setMultipleData] = useState([]);
    const [confustion_metic_data, setConfustionMetricData] = useState([]);
    const [formFields, setFormFields] = useState({
        "title": "Model",
        "fields": [
            { "label": "Model Type", "name": "model_type", "type": "text", "required": true },
            { "label": "Model Name", "name": "model_name", "type": "text", "required": true },
            { "label": "Description", "name": "model_description", "type": "textarea", "required": false },
            //   { "label": "Created By", "name": "created_by", "type": "text", "required": true },
            { "label": "Model Meta", "name": "model_meta", "type": "json", "required": false },
            { "label": "Upload File", "name": "file", "type": "file", "required": true }
        ]
    });
    const [selectedDataset, setSelectedDataset] = useState(null);

    const handleModalClose = () => {
        setOpenModal(false);
    }
    const handleModalOpen = () => {
        setOpenModal(true);
    }
    const geAllmodelsList = () => {
        getModelList()
            .then(data => {
                if (data && data?.length > 0) {
                    setInitialModels(data);
                    setModels(data.map(model => ({
                        ...model,
                        label: model.model_name,
                        id: model.model_id,
                        last_timestamp: model.created_date_time
                    })));
                }
            })
    }


    const handleModelDownload = (model_id) => {
        setModelLoading(true);
        downloadModel(model_id).then(() => {
            console.log(`Downloading model ${model_id}`);
            setModelLoading(false);
        }).catch((e) => {
            triggerAlert('error', e.message);
            setModelLoading(false);
        })
    }


    const filterModels = (e) => {
        if (e.target.value !== "") {
            let filteredModels = initialModels.filter((model) => model.model_name.toLowerCase().includes(e.target.value.toLowerCase()));
            setModels(filteredModels.map(model => ({
                ...model,
                label: model.model_name,
                id: model.model_id,
                last_timestamp: model.created_date_time
            })));
        } else {
            geAllmodelsList();
        }
    }
    useEffect(() => {
        geAllmodelsList();
    }, [])

    const get_Model_metrics = (model_id) => {
        setLoading(true);
        getModelDetail(model_id).then(data => {
            console.log('Model metrics:', data);
            setMetricsData(data);
            for (let i = 0; i < data?.evaluation_metrics?.length; i++) {
                if (data.evaluation_metrics[i].dataset_id && i == 0) {
                    setSingleData(data.evaluation_metrics[i].overall_metrics);
                    setMultipleData(data.evaluation_metrics[i].class_wise_metrics);
                    setConfustionMetricData(data.evaluation_metrics[i].confusion_matrix);
                    setSelectedDataset(data.evaluation_metrics[i].dataset_id);
                    break;
                }
            }
            setLoading(false);
        }).catch(e => {
            triggerAlert('error', e.message);
            setLoading(false);
        })
    }

    const handleModelClick = (element, index) => {
        get_Model_metrics(element.id);
        setSelectedModel(element);
        setShowModelView(true)
        setSingleData([]);
        setMultipleData([]);
        setConfustionMetricData([]);
    }
    const chartData = metricsData?.metrics?.epochs.map((epoch, index) => ({
        epoch,
        accuracy: metricsData.metrics.accuracy[index] * 100,
        loss: metricsData.metrics.loss[index],
        val_accuracy: metricsData.metrics.val_accuracy[index] * 100,
        val_loss: metricsData.metrics.val_loss[index],
    })) || [];

    const handleDatasetChange = (event) => {
        const datasetId = parseInt(event.target.value);
        const selectedData = metricsData.evaluation_metrics.find(
            (metric) => metric.dataset_id === datasetId
        );

        if (selectedData) {
            setSingleData(selectedData.overall_metrics);
            setMultipleData(selectedData.class_wise_metrics);
            setConfustionMetricData(selectedData.confusion_matrix);
        }

        setSelectedDataset(datasetId);
    };

    const onSubmit = async (formData) => {
        createModel(formData).then(() => {
            triggerAlert('success', 'Model added successfully');
            geAllmodelsList();
            handleModalClose();
        }).catch((e) => {
            triggerAlert('error', e.message);
            handleModalClose();
        })
    };

    return (
        <div className='container-fluid g-2 models-tab-container'>
            <AlertPopup />
            <div className='row g-2'>
                <SearchMenu
                    filterFunction={filterModels}
                    ElementList={models}
                    handleOnClickItem={handleModelClick}
                    selectedItem={selectedModel}
                    buttonAction='Create New'
                    title='Model'
                    isDeleteNotRequired={true}
                    customMenuIcon={<NeuralNetworkSvg />}
                    handleModalOpen={handleModalOpen}
                    handleCloseModal={handleModalClose}
                    open={openModal}
                    handleSubmitConfirmation={handleModalClose}
                    errors={errors}
                    onSubmit={onSubmit}
                    formFields={formFields}
                    setFormFields={setFormFields}
                />
                <div className='col-md-9'>
                    {showModelView && (
                        <div className='model-details-container'>
                            <div className='model-header-continer d-flex p-2 justify-content-start align-items-center'>
                            <button
                                    className='btn btn-dark download-button'
                                    style={{ marginLeft: "1%" }}
                                    onClick={() => handleModelDownload(selectedModel.model_id)}
                                    disabled={modelLoading}
                                >
                                    {modelLoading ?<>Downloading <CircularProgress color="white" style={{
                                    width:"18px",
                                    height:'18px'
                                   }}  /> </> : <><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 me-2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                                    </svg>
                                   Download Model</>} 
                                </button>
                            </div>
                            <FilesInfo selectedFileInfo={selectedModel} numberType='' />

                            {loading ? (
                                <CircularProgress />
                            ) : !metricsData ? (
                                <Typography>No metrics available</Typography>
                            ) : (
                                <Card className='p-4 !shadow-none !border-0 models-metrics-card'>
                                    <CardContent>
                                        <Typography variant='h6' gutterBottom>
                                            Model Training Metrics
                                        </Typography>
                                        <div className='flex flex-row w-full gap-4 graphs-view-container'>
                                            {/* Accuracy Graph (Left Side) */}
                                            <div className='graph-container'>
                                                <Card className='p-4 !shadow-none !border-0 graph-card'>
                                                    <CardContent>
                                                        <Typography
                                                            variant='h6'
                                                            gutterBottom
                                                            className='graph-header'
                                                        >
                                                            Accuracy Progression
                                                        </Typography>
                                                        <ResponsiveContainer width='100%' height={300}>
                                                            <LineChart
                                                                data={chartData}
                                                                margin={{
                                                                    top: 10,
                                                                    right: 20,
                                                                    left: 10,
                                                                    bottom: 10,
                                                                }}
                                                            >
                                                                <CartesianGrid strokeDasharray='3 3' />
                                                                <XAxis
                                                                    dataKey='epoch'
                                                                    label={{
                                                                        value: "Epochs",
                                                                        position: "insideBottom",
                                                                        offset: -5,
                                                                    }}
                                                                />
                                                                <YAxis
                                                                    domain={[0, 100]}
                                                                    label={{
                                                                        value: "Accuracy (%)",
                                                                        angle: -90,
                                                                        position: "insideLeft",
                                                                        dy: 50, // Moves the label down for centering
                                                                    }}
                                                                    stroke='#5D4037'
                                                                />
                                                                <Tooltip />
                                                                <Legend verticalAlign='top' height={36} />
                                                                <Line
                                                                    type='linear'
                                                                    dataKey='accuracy'
                                                                    stroke='#E53935'
                                                                    strokeWidth={2}
                                                                    dot={{ r: 4, fill: "#E53935" }}
                                                                    name='Train Accuracy (%)'
                                                                />
                                                                <Line
                                                                    type='linear'
                                                                    dataKey='val_accuracy'
                                                                    stroke='#4CAF50'
                                                                    strokeWidth={2}
                                                                    dot={{ r: 4, fill: "#4CAF50" }}
                                                                    name='Validation Accuracy (%)'
                                                                />
                                                            </LineChart>
                                                        </ResponsiveContainer>
                                                    </CardContent>
                                                </Card>
                                            </div>

                                            {/* Loss Graph (Right Side) */}
                                            <div className='graph-container'>
                                                <Card className='p-4 !shadow-none !border-0 graph-card'>
                                                    <CardContent>
                                                        <Typography
                                                            variant='h6'
                                                            gutterBottom
                                                            className='graph-header'
                                                        >
                                                            Loss Progression
                                                        </Typography>
                                                        <ResponsiveContainer width='100%' height={300}>
                                                            <LineChart
                                                                data={chartData}
                                                                margin={{
                                                                    top: 10,
                                                                    right: 20,
                                                                    left: 10,
                                                                    bottom: 10,
                                                                }}
                                                            >
                                                                <CartesianGrid strokeDasharray='3 3' />
                                                                <XAxis
                                                                    dataKey='epoch'
                                                                    label={{
                                                                        value: "Epochs",
                                                                        position: "insideBottom",
                                                                        offset: -5,
                                                                    }}
                                                                />
                                                                <YAxis
                                                                    domain={["auto", "auto"]}
                                                                    label={{
                                                                        value: "Loss",
                                                                        angle: -90,
                                                                        position: "insideLeft",
                                                                        dy: 18, // Moves the label down for centering
                                                                    }}
                                                                    stroke='#5D4037'
                                                                />
                                                                <Tooltip />
                                                                <Legend verticalAlign='top' height={36} />
                                                                <Line
                                                                    type='linear'
                                                                    dataKey='loss'
                                                                    stroke='#E53935'
                                                                    strokeWidth={2}
                                                                    dot={{ r: 4, fill: "#E53935" }}
                                                                    name='Train Loss'
                                                                />
                                                                <Line
                                                                    type='linear'
                                                                    dataKey='val_loss'
                                                                    stroke='#4CAF50'
                                                                    strokeWidth={2}
                                                                    dot={{ r: 4, fill: "#4CAF50" }}
                                                                    name='Validation Loss'
                                                                />
                                                            </LineChart>
                                                        </ResponsiveContainer>
                                                    </CardContent>
                                                </Card>
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>
                            )}
                            {loading ? (
                                <CircularProgress />
                            ) : !metricsData ? (
                                <Typography>No evaluation metrics available</Typography>
                            ) : (
                                <>
                                    <Card className='p-4 !shadow-none !border-0 models-metrics-card'>
                                        <CardContent>
                                            <div
                                                className='model-header-continer d-flex p-2 flex justify-between'
                                                style={{
                                                    width: "-webkit-fill-available",
                                                    justifyContent: "space-between",
                                                }}
                                            >
                                                <Typography
                                                    variant='h6'
                                                    className='text-lg font-semibold text-gray-800 w-auto'
                                                >
                                                    Evaluation Metrics
                                                </Typography>
                                                {metricsData?.evaluation_metrics && metricsData?.evaluation_metrics.length>0 && <select
                                                    className='form-select border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm w-auto'
                                                    value={selectedDataset || ""}
                                                    onChange={handleDatasetChange}
                                                >
                                                    <option value='' disabled>
                                                        Select Dataset
                                                    </option>
                                                    {metricsData?.evaluation_metrics?.map((metric) => (
                                                        <option
                                                            key={metric.dataset_id}
                                                            value={metric.dataset_id}
                                                        >
                                                            {metric.dataset_name}
                                                        </option>
                                                    ))}
                                                </select>}
                                            </div>
                                            {
                                                (singleData && Object.keys(singleData).length > 0) || (multipleData && Object.keys(multipleData).length > 0) || (confustion_metic_data && Object.keys(confustion_metic_data).length > 0) ?

                                                    <div className='flex flex-row w-full gap-4 graphs-view-container'>
                                                        {/* Loss Graph (Right Side) */}
                                                        <div className='graph-container'>
                                                            <Card className='p-4 !shadow-none !border-0 graph-card'>
                                                                <CardContent>
                                                                    {singleData && Object.keys(singleData).length > 0 ?
                                                                        <ResponsiveContainer width='100%' height={300}>
                                                                            <BarChart
                                                                                data={singleData}
                                                                                title='Overall Metrics'
                                                                            />
                                                                        </ResponsiveContainer> :
                                                                        <p>No Data Found</p>}
                                                                </CardContent>
                                                            </Card>
                                                        </div>

                                                        {/* Loss Graph (Right Side) */}
                                                        <div className='graph-container'>
                                                            <Card className='p-4 !shadow-none !border-0 graph-card'>
                                                                <CardContent>
                                                                    {multipleData && Object.keys(multipleData).length > 0 ?
                                                                        <ResponsiveContainer width='100%' height={300}>
                                                                            <BarChart
                                                                                data={multipleData}
                                                                                title='Class Wise Metrics'
                                                                            />
                                                                        </ResponsiveContainer> :
                                                                        <p>No Data Found</p>}
                                                                </CardContent>
                                                            </Card>
                                                        </div>
                                                    </div>
                                                    :
                                                    <p>No Data Found</p>
                                            }
                                        </CardContent>
                                    </Card>
                                    {
                                        (singleData && Object.keys(singleData).length > 0) || (multipleData && Object.keys(multipleData).length > 0) || (confustion_metic_data && Object.keys(confustion_metic_data).length > 0) ?
                                            <Card className='p-4 !shadow-none !border-0 models-metrics-card'>
                                                <CardContent>
                                                    {/* <div className='flex flex-row w-full gap-4 graphs-view-container'> */}
                                                        {/* Loss Graph (Right Side) */}
                                                        {/* <div className='graph-container'> */}
                                                            <Card className='p-4 !shadow-none !border-0 graph-card'>
                                                                <CardContent>
                                                                    {confustion_metic_data &&
                                                                        Object.keys(confustion_metic_data).length > 0 ? (
                                                                        <ResponsiveContainer width='100%'>

                                                                            <ConfusionMatrixHeatmap
                                                                                data={confustion_metic_data}
                                                                                title='Confusion Metrics'
                                                                            />

                                                                        </ResponsiveContainer>
                                                                    ) :
                                                                        <p>No Data Found</p>}
                                                                </CardContent>
                                                            </Card>
                                                        {/* </div> */}
                                                    {/* </div> */}
                                                </CardContent>
                                            </Card> : ''
                                    }
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
